import { useContainer } from '../../useContainer';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { CreateProjectDto, AssigneeDto } from '../../../commonTypes/project.types';
import { ICallback } from '../../../commonTypes/hook.types';
import { dispatch } from '../../../store';
import { addProject } from '../../../store/slices/projects.slice';
import { useLocation, useNavigate } from 'react-router';
import { useTranslation } from '../../useTranslation';

const useHttpPostProject = () => {
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation('newNotifications');

    const execSubmit = (body: CreateProjectDto, assignees: AssigneeDto[] | undefined, clientName: string | undefined, callback: ICallback) => {
        const { exec, abort } = projectApi.create({
            body: {
                ...body,
                assignees,
            },
            onSuccess: (res: any) => {
                toastHandler.push('success', t('projects.projectCreationTitle'), t('projects.projectCreationMessage_Success'));

                const project = {
                    ...res.body,
                    clientName: clientName,
                };
                dispatch(addProject(project));
                if (location.pathname.startsWith('/projects')) navigate(`/project/${project.id}`);

                if (callback.onSuccess) callback.onSuccess(res.body);
            },
            onError: _ => toastHandler.push('error', t('projects.projectCreationTitle'), t('projects.projectCreationMessage_Failed')),
        });
        exec();
        return abort;
    };

    return { execSubmit };
};

export default useHttpPostProject;
